import React, { Component } from "react";
import { UserLogin, UserData } from "../../api/index";
import Button from "react-bootstrap/Button";
import { Col, Row, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./Login.scss";

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            password: "",
            email: "",
            formError: [],
            user: {},
            passwordVisible: false,
        };
    }

    componentDidMount() {
        UserData()
            .then((response) => {
                if (response.id) {
                    this.props.history.push("/applications");
                }
            })
            .catch((err) => {
                this.setState({
                    user: null,
                });
            });
    }

    validateForm = () => {
        return this.state.email.length > 0 && this.state.password.length > 0;
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const payload = {
            email: this.state.email,
            password: this.state.password,
        };
        UserLogin(payload)
            .then((response) => {
                this.props.refreshLogin();
                this.props.history.push("/applications");
            })
            .catch((error) => {
                this.setState({ formError: error.data.errors });
                this.setState({ message: error.data.message });
            });
    };

    handleChange = (event) => {
        const input = event.target;
        const value = input.type === "checkbox" ? input.checked : input.value;
        this.setState({ [input.name]: value });
    };

    togglePasswordVisibility = () => {
        this.setState({ passwordVisible: !this.state.passwordVisible });
    };

    render() {
        const { email, password, message, formError, user, passwordVisible } =
            this.state;
        return (
            <div>
                <div className="Login-page">
                    <div className="Login-header">
                        <h1>STRATUS</h1>
                    </div>
                    {user == null ? (
                        <Form onSubmit={this.handleSubmit}>
                            <h2>STRATUS | Sign In</h2>
                            <div className="floating-form">
                                <Form.Group
                                    size="lg"
                                    controlId="email"
                                    className="position-relative"
                                >
                                    <Form.Control
                                        placeholder="Email"
                                        type="email"
                                        value={email}
                                        onChange={(e) =>
                                            this.setState({
                                                email: e.target.value,
                                                message: "",
                                            })
                                        }
                                    />
                                    <Form.Label className="floating-label">
                                        Email
                                    </Form.Label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {formError && formError.email
                                            ? formError.email
                                            : null}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                            <div className="floating-form">
                                <Form.Group
                                    size="lg"
                                    controlId="password"
                                    className="position-relative"
                                >
                                    <Form.Control
                                        type={
                                            passwordVisible
                                                ? "text"
                                                : "password"
                                        }
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) =>
                                            this.setState({
                                                password: e.target.value,
                                                message: "",
                                            })
                                        }
                                    />
                                    <Form.Label className="floating-label">
                                        Password
                                    </Form.Label>
                                    <div className="eye-icon">
                                        <FontAwesomeIcon
                                            icon={
                                                passwordVisible
                                                    ? faEyeSlash
                                                    : faEye
                                            }
                                            className="password-icon"
                                            onClick={
                                                this.togglePasswordVisibility
                                            }
                                        />
                                    </div>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {formError && formError.password
                                            ? formError.password
                                            : null}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                            <Form.Control.Feedback
                                type="invalid"
                                className="text-capitalize"
                            >
                                {message}
                            </Form.Control.Feedback>
                            <Button
                                block
                                size="lg"
                                type="submit"
                                onClick={this.handleSubmit}
                                disabled={!this.validateForm()}
                            >
                                Sign In →
                            </Button>
                            <div className="forgetpassword">
                                <Link to="/forgotPassword">
                                    Forget Password?{" "}
                                </Link>
                            </div>
                        </Form>
                    ) : (
                        ""
                    )}

                    <div className="copy-right">
                        <p>Copyright © PaymentCloud. All Rights Reserved.</p>
                    </div>
                </div>
                <div className="background-div">
                    <img
                        src="/images/dot_bg.png"
                        alt="background"
                        className="background"
                    />
                </div>
            </div>
        );
    }
}
